/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const COMMAND_CENTER_MODERNIZATION_DESCRIPTION_ALLOWED = (level) => (
    <FormattedMessage
        id='command_center.upgrade_tooltip.command_center_modernization_description_allowed'
        defaultMessage='Нажмите, чтобы модернизировать Командный центр, что позволит модернизировать все строения до {level} уровня'
        values={{ level }}
    />
)

export const MODERNIZATION_TOOLTIP_TITLE = (
    <FormattedMessage
        id='command_center.upgrade_tooltip.modernization_tooltip_title'
        defaultMessage='Модернизация'
    />
)

export const MODERNIZATION_NOT_AVAILABLE_TITLE = (
    <FormattedMessage
        id='command_center.upgrade_tooltip.modernization_not_available_title'
        defaultMessage='Модернизация не доступна'
    />
)

export const NOT_ENOUGH_BUILDINGS_LEVEL = (level) => (
    <FormattedMessage
        id='command_center.upgrade_tooltip.not_enough_buildings_level'
        defaultMessage='Для модернизации командного центра требуется суммарный уровень строений не ниже {level}'
        values={{ level }}
    />
)

export const NOT_ENOUGH_BUILDINGS_LEVEL_DESCRIPTION = (
    <FormattedMessage
        id='command_center.upgrade_tooltip.not_enough_buildings_level_description'
        defaultMessage='Модернизируйте другие строения Укрепрайона'
    />
)


export const COMMAND_CENTER_MODERNIZATION_DESCRIPTION = (level) => (
    <FormattedMessage
        id='command_center.upgrade_tooltip.command_center_modernization_description'
        defaultMessage='После модернизации Командного центра станет доступна модернизация всех строений до {level} уровня'
        values={{ level }}
    />
)



// WEBPACK FOOTER //
// ./containers/CommandCenterCard/components/UpgradeTooltip/constants.jsx